import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ClearedRec20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.00012 11.5605L14.0608 6.50001L13.0001 5.43934L9.00011 9.43925L7.00009 7.43934L5.93946 8.50003L9.00012 11.5605Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 1.75C0.809645 1.75 0.25 2.30964 0.25 3V14.5C0.25 15.1904 0.809644 15.75 1.5 15.75H4.25V17.7929C4.25 18.9065 5.59643 19.4642 6.38389 18.6768L9.31066 15.75H18.5C19.1904 15.75 19.75 15.1904 19.75 14.5V3C19.75 2.30964 19.1904 1.75 18.5 1.75H1.5ZM1.75 14.25V3.25H18.25V14.25H8.68934L5.75 17.1893V14.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

ClearedRec20.displayName = 'ClearedRec20';
export default ClearedRec20;
